/**
 * A failure the server described.
 *
 * Its own module, and that is not tidiness: this file touches no browser API,
 * so a test can import it without dragging `fetch` into a compilation unit
 * that has no DOM. `lib/api.ts` does the requesting and is typed against the
 * browser; the shared vocabulary of a failure is not.
 */
export class ApiError extends Error {
  public override readonly name = 'ApiError';

  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    /** Echoed by the server so a customer can quote it in a support request. */
    public readonly requestId: string | null,
  ) {
    super(message);
  }
}

/**
 * A request abandoned because no answer came in time.
 *
 * Not an `ApiError`: the server described nothing. Its own class, rather than
 * the browser's `AbortError`, because what it means depends on what was asked.
 * A read that timed out can simply be asked again; a write that timed out may
 * have been carried out all the same, and the sentence somebody reads has to
 * say so before they press the button a second time.
 */
export class RequestTimeout extends Error {
  public override readonly name = 'RequestTimeout';

  constructor(
    /** Whether the request could have changed something on the server. */
    public readonly write: boolean,
  ) {
    super(write ? 'No answer in time; the change may have been made.' : 'No answer in time.');
  }
}
